import { IArticlesItem, IDraftEmailItem } from "modules/Content/interfaces";
import { serializeDraftEmails } from "../utils";

import store from "store";
import { getQueryParam, objectToQueryParams } from "utils";

// Services & actions
import {
  ASSET_DELETE,
  ASSET_DELETED,
  ASSET_DETAILS,
  ASSET_DETAILS_ADD_NEW_DRAFT,
  ASSET_LIST,
  EMAIL_LIST,
  GET_ASSET_REMINDER,
  POST_ASSET_REMINDER,
  PREVIOUSLY_SENT_CONTENT,
} from "constants/types";
import { getEmailsService, getScheduledEmailService, getSentEmailService } from "modules/Services/EmailService";
import {
  createCampaignService,
  createEmailService,
  deleteAssetService,
  digestPreviouslySent,
  getAssetsService,
  getCampaignDataService,
  getCampaignsDashboardGraphDataService,
  saveSentAsDraftEditionCampaignService,
  updateAssetService,
} from "modules/Services/CampaignsService";
import { IAssetItem, IGraphData } from "../interfaces";
import {
  ADD_CURATED_CONTENT,
  ALL_ARTICLES_IN_EDITION,
  DESIGN,
  EMAIL_BROWSER,
  EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL,
  PREVIEW_ARTICLE,
  SEARCH_ARTICLES,
} from "constants/actionTypes";
import { serializeArticle } from "modules/Content/WhatsHappeningNow/utils";
import { openArticleSidebarPreview, closeOverlay } from "modules/GlobalActions";
import {
  addingCuratedContentUrlService,
  activateAssetService,
  uploadArticleByFileService,
  getAssetReminderService,
  postAssetReminderService,
} from "modules/Services/AssetService";
import { storeLoading } from "../AssetsWithOutCampaigns/actions";

export const getCampaignDetails = () => {
  let campaignId = getQueryParam("campaign_id");
  getCampaignDataService(campaignId)
    .then(({ data }) => {
      store.dispatch({
        type: ASSET_LIST.ADVANCED_SEARCH,
        include_sources: data.include_sources,
        exclude_sources: data.exclude_sources,
        include_keywords: data.campaign_keywords,
        exclude_keywords: data.exclude_keywords,
      });
      store.dispatch({
        type: EMAIL_LIST.SET_CAMPAIGN_DETAILS,
        campaignName: data.campaign_name,
        campaignKeywords: data.campaign_keywords,
        campaignId: data.campaign_id,
      });
      store.dispatch({
        // This action will update the searched terms in the store that are to be highlighted in the article preview sidebar
        type: PREVIEW_ARTICLE.UPDATE_SEARCH_TERMS,
        payload: data.campaign_keywords,
      });
      if (data.campaign_keywords.length === 0) {
        store.dispatch({
          type: SEARCH_ARTICLES.LOAD_FAIL,
        });
      }
    })
    .catch((err) => {
      console.log("Error : ", err);
    });
};

export const getEmailDashboardGraphData = (params: any, callback?: any) => {
  getCampaignsDashboardGraphDataService(params).then((res: any) => {
    const serializedData: IGraphData = res.data;
    store.dispatch({
      type: EMAIL_LIST.GRAPH_SUCCESS,
      graph: {
        start_date: params.start_date,
        end_date: params.end_date,
        user_id: params.user_id,
        data: serializedData,
      },
    });

    if (callback)
      callback({
        accumulated_campaigns_clicks: res.data.accumulated_campaigns_clicks,
        accumulated_campaigns_opens: res.data.accumulated_campaigns_opens,
      });
  });
};

export function getEmails(campaignId: number, params: any, isFiltered = false, reset?: boolean) {
  let queryParams = objectToQueryParams(params);
  store.dispatch({
    type: EMAIL_LIST.DRAFT_LOAD,
  });
  getEmailsService(campaignId, queryParams)
    .then((res) => {
      const emailList: IDraftEmailItem[] = serializeDraftEmails(res.data);
      store.dispatch({
        type: EMAIL_LIST.DRAFT_SUCCESS,
        payload: emailList,
        isFiltered: isFiltered,
        reset: reset,
      });
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: EMAIL_LIST.DRAFT_FAIL,
      });
      // show error alert on frontend
    });
}

export function getScheduledEmails(campaignId: number, params?: any) {
  store.dispatch({
    type: EMAIL_LIST.SCHEDULED_LOAD,
  });
  let queryParams = objectToQueryParams(params);

  getScheduledEmailService(campaignId, queryParams)
    .then((res: any) => {
      if (!res.data.message) {
        let emails = res?.data?.versions;
        if (emails) {
          store.dispatch({
            type: EMAIL_LIST.SCHEDULED_SUCCESS,
            payload: emails,
            totalEmails: res.data.total_versions,
            isPaginated: params.limit ? true : false,
            limit: params.limit,
          });
        }
      } else {
        // α case in search
        store.dispatch({
          type: EMAIL_LIST.ERROR_SEARCH_TERM,
          payload: { message: res.data.message, success: false },
        });
        store.dispatch({
          type: EMAIL_LIST.ERROR_SEARCH_TERM_LOADING,
        });
      }
    })
    .catch((err: any) => {
      console.log("Error : getScheduledEmailService : ", err);
      store.dispatch({ type: EMAIL_LIST.SCHEDULED_FAIL });
    });
}

export function getSentEmails(campaignId: number, params: any, isFiltered = false, reset?: boolean) {
  store.dispatch({
    type: EMAIL_LIST.SENT_LOAD,
  });
  let queryParams = objectToQueryParams(params);
  getSentEmailService(campaignId, queryParams)
    .then((res: any) => {
      if (res.data.asset_id) {
        let emails = res?.data?.versions;
        let totalEmails = res?.data?.total_versions;
        if (emails) {
          store.dispatch({
            type: EMAIL_LIST.SENT_SUCCESS,
            payload: emails,
            isFiltered: isFiltered,
            limit: params.limit,
            totalEmails: totalEmails,
            reset: reset,
          });
        }
      } else {
        // α case in search
        store.dispatch({
          type: EMAIL_LIST.ERROR_SEARCH_TERM,
          payload: { message: res.data.message, success: false },
        });
        store.dispatch({
          type: EMAIL_LIST.ERROR_SEARCH_TERM_LOADING,
        });
      }

      store.dispatch({ type: EMAIL_LIST.SENT_LOAD_OFF });
    })
    .catch((err: any) => {
      console.log("Error : getAssetSentVersionsService : ", err);
      store.dispatch({ type: EMAIL_LIST.SENT_FAIL });
    });
}

export function resetSentEmails() {
  store.dispatch({
    type: EMAIL_LIST.SENT_RESET,
  });
}

export function getTestEmails(campaignId: number, params: any, isFiltered = false, reset?: boolean) {
  store.dispatch({
    type: EMAIL_LIST.TEST_LOAD,
  });
  let queryParams = objectToQueryParams(params);
  getSentEmailService(campaignId, queryParams)
    .then((res: any) => {
      if (res.data.asset_id) {
        let emails = res?.data?.versions;
        let totalEmails = res?.data?.total_versions;
        if (emails) {
          store.dispatch({
            type: EMAIL_LIST.TEST_SUCCESS,
            payload: emails,
            isFiltered: isFiltered,
            limit: params.limit,
            totalEmails: totalEmails,
            reset: reset,
          });
        }
      } else {
        // α case in search
        store.dispatch({
          type: EMAIL_LIST.ERROR_SEARCH_TERM,
          payload: { message: res.data.message, success: false },
        });
        store.dispatch({
          type: EMAIL_LIST.ERROR_SEARCH_TERM_LOADING,
        });
      }

      store.dispatch({ type: EMAIL_LIST.TEST_LOAD_OFF });
    })
    .catch((err: any) => {
      console.log("Error : getAssetSentVersionsService : ", err);
      store.dispatch({ type: EMAIL_LIST.TEST_FAIL });
    });
}

export function resetTestEmails() {
  store.dispatch({
    type: EMAIL_LIST.TEST_RESET,
  });
}

export function resetScheduledEmails() {
  store.dispatch({
    type: EMAIL_LIST.SCHEDULED_RESET,
  });
}

export function getAllEmails(campaignId: number, params: any, isFiltered = false, reset?: boolean) {
  store.dispatch({
    type: EMAIL_LIST.ALL_LOAD,
  });
  let queryParams = objectToQueryParams(params);

  getSentEmailService(campaignId, queryParams)
    .then((res: any) => {
      if (res.data.asset_id) {
        let emails = res?.data?.versions;
        let totalEmails = res?.data?.total_versions;
        if (emails) {
          store.dispatch({
            type: EMAIL_LIST.ALL_SUCCESS,
            payload: emails,
            isFiltered: isFiltered,
            limit: params.limit,
            totalEmails: totalEmails,
            reset: reset,
          });
        }
      } else {
        // α case in search
        store.dispatch({
          type: EMAIL_LIST.ERROR_SEARCH_TERM,
          payload: { message: res.data.message, success: false },
        });
        store.dispatch({
          type: EMAIL_LIST.ERROR_SEARCH_TERM_LOADING,
        });
      }

      store.dispatch({ type: EMAIL_LIST.ALL_LOAD_OFF });
    })
    .catch((err: any) => {
      console.log("Error : getAssetSentVersionsService : ", err);
      store.dispatch({ type: EMAIL_LIST.ALL_FAIL });
    });
}

export function getAllEmailsSent(campaignId: number, params: any, isFiltered = false, reset?: boolean) {
  store.dispatch({
    type: EMAIL_LIST.ALL_SENT_LOAD,
  });
  let queryParams = objectToQueryParams(params);
  getSentEmailService(campaignId, queryParams)
    .then((res: any) => {
      if (res.data.asset_id) {
        let emails = res?.data?.versions;
        let totalEmails = res?.data?.total_versions;
        if (emails) {
          store.dispatch({
            type: EMAIL_LIST.ALL_SENT_SUCCESS,
            payload: emails,
            isFiltered: isFiltered,
            limit: params.limit,
            totalEmails: totalEmails,
            reset: reset,
          });
        }
      } else {
        // α case in search
        store.dispatch({
          type: EMAIL_LIST.ERROR_SEARCH_TERM,
          payload: { message: res.data.message, success: false },
        });
        store.dispatch({
          type: EMAIL_LIST.ERROR_SEARCH_TERM_LOADING,
        });
      }

      store.dispatch({ type: EMAIL_LIST.ALL_SENT_LOAD_OFF });
    })
    .catch((err: any) => {
      console.log("Error : getAssetSentVersionsService : ", err);
      store.dispatch({ type: EMAIL_LIST.ALL_SENT_FAIL });
    });
}
// to reset 'ALL' tabs campaigns emails
export function resetAllEmails() {
  store.dispatch({
    type: EMAIL_LIST.ALL_RESET,
  });
}

// to reset all sent emails of campaigns
export function resetAllSentEmails() {
  store.dispatch({
    type: EMAIL_LIST.ALL_SENT_RESET,
  });
}

// to reset all emails sent, test, schedule and All
export function resetAll() {
  store.dispatch({
    type: EMAIL_LIST.RESET_ALL,
  });
}

export function resetEmailsConditionally(enableTabs?: boolean, tabState?: string) {
  if (enableTabs) {
    resetAll();
  } else {
    resetAllSentEmails();
    resetScheduledEmails();
  }
}

export function getEmailsConditionally(
  campaignId: number,
  params: any,
  isFiltered = false,
  reset?: boolean,
  enableTabs?: boolean,
  tabState?: string
) {
  if (enableTabs) {
    if (tabState === "sent") {
      getSentEmails(campaignId, params, isFiltered, reset);
    } else if (tabState === "test") {
      getTestEmails(campaignId, params, isFiltered, reset);
    } else if (tabState === "scheduled") {
      getScheduledEmails(campaignId, params);
    } else if (tabState === "all") {
      getAllEmails(campaignId, params, isFiltered, reset);
    }
  } else {
    getAllEmailsSent(campaignId, params, isFiltered, reset);
  }
}

export function resetEmails() {
  store.dispatch({
    type: EMAIL_LIST.DRAFT_RESET,
  });
}

export const getCampaignsData = () => {
  let campaignId = getQueryParam("campaign_id");
  getCampaignDataService(campaignId)
    .then(({ data }) => {
      store.dispatch({
        type: ASSET_LIST.SET_CAMPAIGN_DETAILS,
        campaign_name: data.campaign_name,
        campaign_keywords: data.campaign_keywords,
      });

      store.dispatch({
        // This action will update the searched terms in the store that are to be highlighted in the article preview sidebar
        type: PREVIEW_ARTICLE.UPDATE_SEARCH_TERMS,
        payload: data.campaign_keywords,
      });
    })
    .catch((err) => {
      console.log("Error : ", err);
    });
};

export const getAssetsList = (params: any) => {
  const queryParams = objectToQueryParams(params);

  store.dispatch({
    type: ASSET_LIST.LOAD,
    payload: [],
  });
  getAssetsService(queryParams)
    .then(({ data }: any) => {
      const assetList: IAssetItem[] = data;
      store.dispatch({
        type: ASSET_LIST.SUCCESS,
        payload: assetList,
      });
    })
    .catch((err) => {
      console.log(err);
      store.dispatch({
        type: ASSET_LIST.FAIL,
        payload: Array<IAssetItem>(),
      });
      // show error alert on frontend
    });
};

export const deleteAsset = (asset_index: number, assetId: string, campaignId: string) => {
  deleteAssetService(assetId).then((response) => {
    if (response.status === 200) {
      store.dispatch({
        type: ASSET_DELETE.SUCCESS,
        payload: asset_index,
      });
      store.dispatch({
        type: ASSET_DELETED,
        payload: parseInt(campaignId),
      });
    }
  });
};
{
  /* action to display sent articles/ content in 
the previously sent tab in the assets page in campaign tab */
}

export const getPreviouslySentContent = (id: any) => {
  store.dispatch({
    type: PREVIOUSLY_SENT_CONTENT.LOAD,
    payload: [],
  });
  digestPreviouslySent(id)
    .then(({ data }: any) => {
      store.dispatch({
        type: PREVIOUSLY_SENT_CONTENT.LOAD_SUCCESS,
        payload: data,
      });
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: PREVIOUSLY_SENT_CONTENT.LOAD_FAIL,
        payload: [],
      });
      // show error alert on frontend
    });
};

export const createAssetAction = (asset_name: string, campaign_id: string) => {
  store.dispatch({
    type: EMAIL_LIST.EMAIL_IN_EXISTING_CAMPAIGN,
    payload: true,
    campaignId: campaign_id,
  });
  return createEmailService(asset_name, campaign_id);
};

export const updateAssetAction = (emailName: string, emailId: string, campaignId?: string) => {
  return updateAssetService(emailName, emailId, campaignId);
};

export const createCampaign = (
  campaignName: string,
  campaignKeywords: string[],
  contactIds: number[] = [],
  listIds: number[] = [],
  advancedFilter?: boolean,
  sourcedContent?: any[],
  excludedContent?: any[],
  excludedKeywords?: string[],
  includedKeywords?: string[]
) => {
  const pathname = window.location.pathname;
  store.dispatch({
    type: EMAIL_BROWSER.RESET_EDITIONS_IN_ASSET,
  });
  store.dispatch({
    type: ASSET_LIST.RESET_ADVANCED_SEARCH,
  });
  store.dispatch({
    type: SEARCH_ARTICLES.RESET_ADVANCED_SEARCH,
  });
  return pathname.startsWith("/content/search")
    ? createCampaignService(
        campaignName,
        campaignKeywords,
        contactIds,
        listIds,
        true,
        sourcedContent,
        excludedContent,
        excludedKeywords,
        includedKeywords
      )
    : createCampaignService(campaignName, campaignKeywords, contactIds, listIds);
};

export const addCuratedContentByURL = (url: string, callback: any, emailId?: number) => {
  store.dispatch({
    type: ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_LOAD,
    addByUrl: true,
  });
  addingCuratedContentUrlService(url)
    .then((res: any) => {
      if (res.data.success === false) {
        store.dispatch({
          type: ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_FAILED,
          payload: res.data,
          addByUrl: true,
        });
      } else {
        if (res.status === 200 && res.data.message) {
          store.dispatch({
            type: ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_ALREADY_ADDED,
            payload: {
              message: res.data.message,
            },
            addByUrl: true,
          });
        } else if (res.data) {
          const serializedData: IArticlesItem = serializeArticle(res.data);
          const { id, title, website, entities, publish_date, image_url, link } = serializedData;
          // if the editions articles is zero and added article by url
          // let articlesLength = store.getState().whnArticles.articleofEdition.length;
          // if (articlesLength === 0) {
          openArticleSidebarPreview(
            {
              id,
              title,
              website,
              tags: entities,
              entities,
              publishDate: publish_date,
              image_url,
              article_link: link,
            },
            true
          );
          // }
          store.dispatch({
            type: ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_SUCCESS,
            payload: {
              list: serializedData,
            },
            addByUrl: true,
          });
          store.dispatch({
            type: EMAIL_BROWSER_ADD_ARTICLES_TO_EMAIL.ADD_BY_URL,
            payload: emailId,
          });
        }
      }
      if (callback) {
        callback();
      }
    })
    .catch((error: any) => {
      console.log("couldn't add the article: ", error);
      store.dispatch({
        type: ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_FAILED,
        payload: error,
        addByUrl: true,
      });
    });
};

{
  /* creating a new draft in the assets page  in the campaign section*/
}

export const activateAsset = (assetId: string, activeStatus: string) => {
  activateAssetService(assetId, activeStatus).then((res: any) => {
    store.dispatch({
      type: ASSET_DETAILS.SET_ACTIVE_STATE,
      payload: activeStatus === "1" ? true : false,
    });
  });
};

export const addCuratedContentByFile = (filename: string, chunkIds: any, callback: any) => {
  store.dispatch({
    type: ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_LOAD,
  });
  uploadArticleByFileService({ filename, chunkIds })
    .then((res) => {
      if (res.data.message) {
        store.dispatch({
          type: ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_ALREADY_ADDED,
          payload: {
            message: res.data.message,
          },
        });
      }
      if (res.data) {
        const serializedData: IArticlesItem = serializeArticle(res.data);
        const { id, title, website, entities, publish_date, image_url, link } = serializedData;
        openArticleSidebarPreview(
          {
            id,
            title,
            website,
            tags: entities,
            entities,
            publishDate: publish_date,
            image_url,
            article_link: link,
          },
          true
        );
        store.dispatch({
          type: ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_SUCCESS,
          payload: {
            list: serializedData,
          },
        });
      }
      if (callback) {
        callback();
      }
      closeOverlay();
    })
    .catch((err) => {
      console.log("couldn't add the article: ", err);
      closeOverlay();

      store.dispatch({
        type: ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_FAILED,
        payload: err,
      });
    });
};

export const setReminderToPublishDigest = () => {};

export const resetAddArticle = () => {
  store.dispatch({ type: ADD_CURATED_CONTENT.RESET });
};

export const getAssetDetails = (assetWithoutCampaign?: boolean, loadDrafts?: boolean) => {
  storeLoading(ASSET_DETAILS.LOAD);
};

//* Saving Sent Editions as Draft.
export const saveSentEditionAsDraft = (assetId: any, versionId: any) => {
  storeLoading(ASSET_DETAILS_ADD_NEW_DRAFT.LOAD);
  saveSentAsDraftEditionCampaignService(assetId, versionId)
    .then(({ data }: any) => {
      const date = new Date();
      const newDraftEdition = {
        version_id: data?.id,
        name: data?.name,
        status: "draft",
        last_update: date.getDate() + " " + date.getMonth(),
        sent_date: data?.creation_time.length > 8 ? null : data.creation_time,
        thumbnail: [],
        total_contacts: 0,
        total_sent: 0,
        total_delivery: 0,
        total_open: 0,
        total_clicks: 0,
        curated_articles_count: 0,
        a_or_b: "a",
        description: "",
        title: "",
        link: "",
        cloned: true,
      };
      store.dispatch({
        type: ASSET_DETAILS_ADD_NEW_DRAFT.SUCCESS,
        newDraft: newDraftEdition,
      });
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: ASSET_DETAILS_ADD_NEW_DRAFT.FAIL,
        payload: [],
      });
    });
};

// show error alert on frontend
export const getAssetReminder = (assetId: string) => {
  store.dispatch({
    type: GET_ASSET_REMINDER.LOAD,
    payload: { loading: true },
  });
  getAssetReminderService(assetId)
    .then((res) => {
      if (res.status === 200) {
        store.dispatch({
          type: GET_ASSET_REMINDER.SUCCESS,
          payload: res.data,
        });
      }
    })
    .catch((error: any) => {
      store.dispatch({
        type: GET_ASSET_REMINDER.FAIL,
        payload: { loading: false },
      });
    });
};

export const postAssetReminder = (data: any) => {
  store.dispatch({
    type: POST_ASSET_REMINDER.LOAD,
    payload: { loading: true },
  });
  postAssetReminderService(data)
    .then((res) => {
      if (res.status === 200) {
        store.dispatch({
          type: POST_ASSET_REMINDER.SUCCESS,
          payload: res.data,
        });
      }
    })
    .catch((error: any) => {
      store.dispatch({
        type: POST_ASSET_REMINDER.FAIL,
        payload: { loading: false },
      });
    });
};

export const disablePublishButton = () => {
  store.dispatch({ type: DESIGN.DISABLE_PUBLISH });
};

export const enablePublishButton = () => {
  store.dispatch({ type: DESIGN.ENABLE_PUBLISH });
};
